import {
  ALTAPROTOCOLOPCR_ERROR,
  ALTAPROTOCOLOPCR_LOADING,
  ALTAPROTOCOLOPCR_SUCCESS,
  ALTAPROTOCOLOPCR_RESET,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";

export const altaProtocoloPcrReset = () => (dispatch) => {
  dispatch({
    type: ALTAPROTOCOLOPCR_RESET,
  });
};

export const wsPostAltaProtocoloPcr = (dtoAltaProtocolo) => (dispatch) => {
  dispatch({
    type: ALTAPROTOCOLOPCR_LOADING,
  });

 axiosInstance().then(respuesta => {
  respuesta
  .post("/laboratorio/AltaProtocoloPCR", dtoAltaProtocolo)
  .then((res) => {
    dispatch({
      type: ALTAPROTOCOLOPCR_SUCCESS,
      payload: res.status,
    });
  })
  .catch((err) => {
    let error = {
      detail: err.response
        ? err.response.data
        : "Error al contactar el server.",
      origen: "portal",
    };
  
    dispatch({
      type: ALTAPROTOCOLOPCR_ERROR,
      payload: error,
    });
  });
} )
};
